var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", [
    _vm.backgroundImageUrl
      ? _c(
          "div",
          {
            staticClass: "hero",
            style: { backgroundImage: "url(" + _vm.backgroundImageUrl + ")" }
          },
          [
            _c("div", { staticClass: "hero-content" }, [
              _c("div", { staticClass: "hero-text" }, [
                _vm.headline
                  ? _c("h1", { staticClass: "header__title" }, [
                      _vm._v(_vm._s(_vm.headline))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.tagline
                  ? _c("h4", { staticClass: "header__title" }, [
                      _vm._v(_vm._s(_vm.tagline))
                    ])
                  : _vm._e()
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }